import React, { FC, forwardRef, RefAttributes } from 'react';
import { TextInput } from '@trip-ux/components';
import { FieldRenderProps } from 'react-final-form';
import { get } from 'lodash';
import { SUPPORTED_LOCALES } from '@trip-ux/constants';
import { blurCheck, checkCurrency } from '../../utils';

const mask = (type: string): string | undefined => {
  if (type === 'phone') {
    return '(999)-999-9999';
  } else if (type === 'postalCode') {
    return 'a9a 9a9';
  }
  return undefined;
};

export const GenericPriceInput: FC<
  FieldRenderProps<string> & RefAttributes<HTMLInputElement> & { ariaLabel?: string; locale?: SUPPORTED_LOCALES }
> = forwardRef(
  (
    {
      labels,
      ariaLabel,
      input,
      meta,
      showLabel = false,
      className = '',
      disabled = false,
      id,
      locale = SUPPORTED_LOCALES.ENGLISH
    },
    ref
  ) => {
    const label = get(labels, input.name, '');
    return (
      <div className={`mb-auto space-between ${className}`}>
        <TextInput
          {...input}
          onChange={e => checkCurrency(e, locale, input.onChange)}
          onBlur={e => blurCheck(e, locale, input.onBlur)}
          id={id ? id : input.name}
          disabled={disabled}
          type="text"
          className="my-auto text-input-policy"
          placeholder={label}
          mask={mask(input.name)}
          maskChar="_"
          error={meta.touched && !meta.active && meta.error}
          ref={ref}
          showLabel={showLabel}>
          {showLabel ? label : ariaLabel}
        </TextInput>
      </div>
    );
  }
);
GenericPriceInput.displayName = 'GenericPriceInput';
